import { inject, Pipe, PipeTransform } from '@angular/core';
import { Address } from '../../models/address.model';
import { AbstractTransport } from '../../models/abstract-transport.model';
import { BaryAddressService } from '../../services/bary-address.service';

@Pipe({
  name: 'transportAddress',
  standalone: true,
})
export class TransportAddressPipe implements PipeTransform {
  readonly #addressUtil = inject(BaryAddressService);

  transform(value: AbstractTransport, options: { pickup?: boolean; delivery?: boolean }): string {
    if (!options.pickup && !options.delivery) {
      return '';
    }
    let result = '';
    if (options.pickup) {
      const pickupAddress = new Address();
      pickupAddress.fullname = value.pickupAddressFullname;
      pickupAddress.streetNumber = value.pickupAddressStreetNumber;
      pickupAddress.street = value.pickupAddressStreet;
      pickupAddress.additionals = value.pickupAddressAdditionals;
      pickupAddress.zipCode = value.pickupAddressZipCode;
      pickupAddress.city = value.pickupAddressCity;
      pickupAddress.country = value.pickupAddressCountry;

      result += this.#addressUtil.writeAddress(pickupAddress);
    }
    if (options.delivery) {
      const deliveryAddress = new Address();
      deliveryAddress.fullname = value.deliveryAddressFullname;
      deliveryAddress.streetNumber = value.deliveryAddressStreetNumber;
      deliveryAddress.street = value.deliveryAddressStreet;
      deliveryAddress.additionals = value.deliveryAddressAdditionals;
      deliveryAddress.zipCode = value.deliveryAddressZipCode;
      deliveryAddress.city = value.deliveryAddressCity;
      deliveryAddress.country = value.deliveryAddressCountry;

      result += this.#addressUtil.writeAddress(deliveryAddress);
    }
    return result;
  }
}
